export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: [],
  }),

  getters: {
    currentToast: (state) => {
      return state.toasts.length > 0 ? state.toasts[0] : null;
    },
  },

  actions: {
    add(toast) {
      this.toasts.push({
        ...toast,
      });
    },

    shift() {
      this.toasts.shift();
    },
  },
});
